import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)] pb-6" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-6 py-6 mx-6" }
const _hoisted_3 = { class: "col-span-4" }
const _hoisted_4 = { class: "col-span-4" }
const _hoisted_5 = { class: "col-span-4" }
const _hoisted_6 = { class: "p-6 mx-6 border rounded-lg border-neutral-100" }
const _hoisted_7 = { class: "grid grid-cols-6 gap-6 mt-6" }
const _hoisted_8 = { class: "grid grid-cols-6 col-span-6 gap-6 px-4 py-6 border border-gray-200 rounded-lg" }
const _hoisted_9 = { class: "grid grid-cols-3 col-span-3 gap-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Case Number:")
], -1)
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Full Name:")
], -1)
const _hoisted_13 = { class: "col-span-2" }
const _hoisted_14 = { class: "grid grid-cols-3 col-span-3 gap-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date Initiated:")
], -1)
const _hoisted_16 = { class: "col-span-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Assessment is for patient's sibling:")
], -1)
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = { class: "grid grid-cols-6 col-span-6 gap-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Appointments:")
], -1)
const _hoisted_21 = { class: "col-span-5" }
const _hoisted_22 = { class: "grid grid-cols-6 col-span-6 px-4 py-6 border border-gray-200 rounded-lg gap-9" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 -mb-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Factor")
], -1)
const _hoisted_24 = { class: "col-span-3" }
const _hoisted_25 = { class: "font-medium text-neutral-600" }
const _hoisted_26 = { class: "flex items-center col-span-3" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center space-x-6"
}
const _hoisted_28 = {
  key: 1,
  class: "flex items-center space-x-6"
}
const _hoisted_29 = { class: "col-span-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, " Information supporting safety factor: ", -1)
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "col-span-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, "Brief Family Background", -1)
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "col-span-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, "Family Background", -1)
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Decision Plan")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Risk Codes")
], -1)
const _hoisted_40 = { class: "col-span-2" }
const _hoisted_41 = { class: "col-span-2" }
const _hoisted_42 = { class: "col-span-2" }
const _hoisted_43 = {
  for: "action_plan-1",
  class: "relative flex items-center h-full py-3 pl-3 pr-12 border rounded cursor-pointer border-neutral-100"
}
const _hoisted_44 = { class: "text-xs font-medium text-neutral-600" }
const _hoisted_45 = ["checked", "name", "id"]
const _hoisted_46 = { class: "col-span-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, "Immediate Safety Plan", -1)
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { class: "col-span-6" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, " Rationale of Overall Immediate Safety Assessment ", -1)
const _hoisted_51 = ["innerHTML"]

import { onMounted, ref, computed, watch } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import ExportButton from '@/components/buttons/ExportButton.vue';
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface";
import ReportService from "@/classes/Reports/ReportService";
import SafetyAssessment from "@/classes/Cases/SafetyAssessment";
import { useNetworkStore } from "@/store/network";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSafetyAssessment',
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const caseItem = ref<any>({})
const cases = ref<any>([]);
const questions = ref<renderSelect[]>([]);
const riskCodes = ref<renderSelect[]>([]);
const safetyFactorOptions = ref<renderSelectV2[]>([]);
const item = ref();
const showSync = ref<boolean>(false);


const filters = ref({
    case_id: null,
})

const first_name = computed(() => item.value?.first_name ?? '')
const last_name = computed(() => item.value?.last_name ?? '')
const yes_count = computed(() => item.value?.yes_count ?? '')
const no_count = computed(() => item.value?.no_count ?? '')
const unknown_count = computed(() => item.value?.unknown_count ?? '')

const fetch = () => {
    showSync.value = true

    ReportService.index('safety-assessment', filters.value)
        .then(({ data }) => {
            console.log(data)
            cases.value = data?.cases
            safetyFactorOptions.value = data?.status;
            questions.value = data?.questions;
            riskCodes.value = data?.riskCodes;
            caseItem.value = data?.case;
            item.value = data?.item;

            showSync.value = false
        })
        .catch(errors => {
            showSync.value = false
            console.log(errors)
        });
}

const generatePDFAccess = ():void => {
	SafetyAssessment
		.generatePDFAccess(
			caseItem.value.patient_id,
			caseItem.value.id,
			item.value.id,
            isNetworkAvailable.value
		)
		.then(({data}) => {
			if(data.token){
				downloadPDF(data.token)
			}
		}).catch((errors) => {
			console.log(errors);
		})

}
const downloadPDF = (token:string):void => {
	SafetyAssessment
		.downloadPDF(
			item.value.id,
			token,
			isNetworkAvailable.value
		)
		.then(({data}) => {
			console.log(data);
		}).catch((errors) => {
			console.log(errors);
		})

}

watch(
() => filters.value.case_id,
	() => {
		fetch();
	}
);

onMounted(() => {
    fetch()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Safety Assessment Report",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      (item.value)
        ? (_openBlock(), _createBlock(ExportButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (generatePDFAccess()))
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(MultiSelect, {
              options: cases.value,
              id: "case_number",
              name: "case_number",
              label: "Case Number",
              placeholder: "Select..",
              searchable: "",
              modelValue: filters.value.case_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.case_id) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              placeholder: "Patient last name",
              id: "patient_last_name",
              name: "patient_last_name",
              label: "Patient Last Name",
              disabled: "",
              modelValue: last_name.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((last_name).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TextInput, {
              placeholder: "Patient first name",
              id: "patient_first_name",
              name: "patient_first_name",
              label: "Patient First Name",
              disabled: "",
              modelValue: first_name.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((first_name).value = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, _toDisplayString(item.value?.case_number), 1)
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", null, _toDisplayString(item.value?.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", null, _toDisplayString(item.value?.initiated_at), 1)
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", null, _toDisplayString(item.value?.is_assessment_patient_sibling ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(item.value?.appointment), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "grid grid-cols-6 col-span-6 gap-6",
                  key: question
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", _hoisted_25, _toDisplayString(question.description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    (item.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(RadioGroup, {
                            options: safetyFactorOptions.value,
                            name: `caretaker_${index}`,
                            readonly: "",
                            modelValue: item.value.safety_assessment_questions[index]['status'],
                            "onUpdate:modelValue": ($event: any) => ((item.value.safety_assessment_questions[index]['status']) = $event)
                          }, null, 8, ["options", "name", "modelValue", "onUpdate:modelValue"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(RadioGroup, {
                            options: safetyFactorOptions.value,
                            name: `caretaker_${index}`,
                            readonly: ""
                          }, null, 8, ["options", "name"])
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("p", {
                      innerHTML: item.value?.safety_assessment_questions[index]['supporting_information']
                    }, null, 8, _hoisted_31)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("p", {
                innerHTML: item.value?.brief_family_background
              }, null, 8, _hoisted_34)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("p", {
                innerHTML: item.value?.family_background
              }, null, 8, _hoisted_37)
            ]),
            _hoisted_38,
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createVNode(TextInput, {
                disabled: true,
                type: "number",
                label: "Total number of “Yes”",
                placeholder: "#",
                name: "number_yes",
                id: "number_yes",
                modelValue: yes_count.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((yes_count).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(TextInput, {
                disabled: true,
                type: "number",
                label: "Total number of “No”",
                placeholder: "#",
                name: "number_no",
                modelValue: no_count.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((no_count).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(TextInput, {
                disabled: true,
                type: "number",
                label: "Total number of “Unknown”",
                placeholder: "#",
                name: "number_unknown",
                modelValue: unknown_count.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((unknown_count).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(riskCodes.value, (riskCode, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-span-2",
                key: riskCode
              }, [
                _createElementVNode("label", _hoisted_43, [
                  _createElementVNode("p", _hoisted_44, _toDisplayString(riskCode.description), 1),
                  _createElementVNode("input", {
                    checked: item.value?.risk_code_id == riskCode.id ? true : false,
                    disabled: "",
                    type: "radio",
                    name: `action_plan_${index}`,
                    id: `action_plan_${index}`,
                    class: "absolute z-10 w-6 h-6 border-gray-300 cursor-pointer top-3 right-3 text-primary-600 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-600"
                  }, null, 8, _hoisted_45)
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("p", {
                innerHTML: item.value?.immediate_safety_plan
              }, null, 8, _hoisted_48)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", {
                innerHTML: item.value?.overall_risk_assessment,
                class: "frm-description"
              }, null, 8, _hoisted_51)
            ])
          ])
        ])
      ]),
      _createVNode(LoadingModal, {
        show: showSync.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})